/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  TextField,
  Stack,
  List,
  ListItem,
  ListItemText,
  Typography,
  Container,
  InputLabel,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { green } from "@mui/material/colors";
import SendIcon from "@mui/icons-material/Send";
//import DeleteIcon from "@mui/icons-material/Delete";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import api from "../../../services/api";
import Swal from "sweetalert2";
import { inputsName } from "../../../config/languageConst";
import { useLocation, useParams } from "react-router-dom";
import { LogTrackUser } from "../../../types/log-track-user/log-track-user";
import { AsyncPaginate } from "react-select-async-paginate";
import Cookies from "js-cookie";

export default function EditPaymentMethod() {
  const { id } = useParams<{ id: string }>();
  const [circularLoading, setCircularLoading] = useState(false);
  const [requestError, setRequestError] = useState(false);
  const [requestErrorData, setRequestErrorData] = useState([]);

  //User Tracking Logging Section //////////////////////////////////////
  let [alreadySetLog, setAlreadySetLog] = useState(false);
  const location = useLocation();
  if (!alreadySetLog) {
    LogTrackUser(Cookies.get("username"), location.pathname);
    setAlreadySetLog(true as boolean);
  }
  ///////////////////////////////////////////////////////////////////
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [dependentShippingMethod, setDependentShippingMethod] = useState<{
    id: number;
    code: string;
    name: string;
  } | null>(null);

  const defaultAdditional = {
    page: 1,
  };

  const loadOptionsShippingMethod = async (search: any, page: any) => {
    const results = await api.get(
      `/shipping-methods?page=${page}&search=${search}`
    );

    const hasMore = results.data.total_pages === results.data.current_page;
    return {
      options: results.data.items,
      hasMore: !hasMore,
    };
  };

  const loadPageOptionsShippingMethod = async (
    q: any,
    _prevOptions: any,
    { page }: any
  ) => {
    const { options, hasMore } = await loadOptionsShippingMethod(q, page);
    if (options.length > 0) {
      options.unshift({ id: 0, code: "None" });
    }
    return {
      options,
      hasMore,

      additional: {
        page: page + 1,
      },
    };
  };

  const onSubmit = (payment_method: any) => {
    setCircularLoading(true);
    //let temp = [];
    if (dependentShippingMethod) {
      if (dependentShippingMethod?.id > 0) {
        payment_method.dependent_shipping_method_id =
          dependentShippingMethod?.id;
      } else {
        payment_method.dependent_shipping_method_id = null;
      }
    } else {
      payment_method.dependent_shipping_method_id = null;
    }

    for (let index = 0; index < payment_method.descriptions.length; index++) {
      payment_method.descriptions[index].language_id = Number(
        payment_method.descriptions[index].language_id
      );
    }

    api
      .put(`payment-methods/${id}`, payment_method)
      .then((res) => {
        setCircularLoading(false);
        setRequestError(false);
        Swal.fire({
          title: "Payment Method Updated!",
          icon: "success",
          confirmButtonText: "Yes",
        });
        //reset();
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.response.data.message,
        });
        setCircularLoading(false);
        setRequestError(false);
        setRequestErrorData(error.response.data.message);
      });
  };

  const fetchPaymentMethod = async () => {
    const response = await api.get(`payment-methods/${id}`);
    reset(response.data);
    if (response.data.dependent_shipping_method_id) {
      setDependentShippingMethod(response.data.dependent_shipping_method);
    }
  };

  useEffect(() => {
    fetchPaymentMethod();
  }, []);

  return (
    <Container component="main" maxWidth="xl">
      <div style={{ marginTop: "100px" }}></div>
      <Typography
        component="h1"
        variant="h5"
        sx={{ fontSize: "32px", marginBottom: "15px", color: "#556cd6" }}
      >
        Edit Payment Method {id}
      </Typography>
      {requestError && (
        <List component="nav" aria-label="errors">
          {requestErrorData.map((error) => (
            <ListItem key={error}>
              <ListItemText
                sx={{
                  color: "red",
                }}
                primary={error}
              />
            </ListItem>
          ))}
        </List>
      )}

      <Box
        component="form"
        sx={{
          display: "flex",
          flexDirection: "column",
          minWidth: 3 / 4,
          marginBottom: "30px",
          width: "100%",
        }}
        onSubmit={handleSubmit(onSubmit)}
      >
        <TextField
          margin="normal"
          InputLabelProps={{ shrink: true }}
          required
          fullWidth
          id="code"
          type="text"
          label="Code"
          {...register("code")}
        />
        <p style={{ color: "red", textAlign: "center" }}>
          {errors?.code?.toString()}
        </p>

        <TextField
          margin="normal"
          InputLabelProps={{ shrink: true }}
          required
          fullWidth
          id="name"
          type="text"
          label="Name"
          {...register("name")}
        />
        <p style={{ color: "red", textAlign: "center" }}>
          {errors?.name?.toString()}
        </p>

        <TextField
          margin="normal"
          InputLabelProps={{ shrink: true }}
          fullWidth
          id="payment_company_name"
          type="text"
          label="Payment Company Name"
          {...register("payment_company_name")}
        />
        <p style={{ color: "red", textAlign: "center" }}>
          {errors?.payment_company_name?.toString()}
        </p>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            marginRight: "8px",
            marginLeft: 1,
          }}
        >
          <InputLabel id="payment-method-filter-select">
            Dependent Shipping Method (To activate this Payment Method, the
            following Shipping Method must be chosen before)
          </InputLabel>
          <AsyncPaginate
            placeholder="Select Shipping Method"
            styles={{
              menu: (provided) => ({
                ...provided,
                zIndex: 9999,
              }),
            }}
            additional={defaultAdditional}
            key={"shipping_method"}
            id="shipping_method"
            name="shipping_method"
            value={dependentShippingMethod}
            getOptionValue={(option: any) => option?.id}
            getOptionLabel={(option: any) =>
              option?.code + " / " + option?.name
            }
            loadOptions={loadPageOptionsShippingMethod}
            onChange={setDependentShippingMethod}
          />
        </Box>
        <p style={{ color: "red", textAlign: "center" }}>
          {errors?.dependent_shipping_method_id?.toString()}
        </p>

        <TextField
          margin="normal"
          InputLabelProps={{ shrink: true }}
          fullWidth
          id="additional_info"
          type="text"
          multiline
          rows={5}
          label="Additional Info"
          {...register("additional_info")}
        />
        <p style={{ color: "red", textAlign: "center" }}>
          {errors?.additional_info?.toString()}
        </p>

        <Box sx={{ width: "100%", typography: "body1" }}>
          <div style={{ marginTop: "30px" }}>
            {inputsName.map((input, index) => (
              <div
                key={index}
                className="flags-container"
                style={{ display: "block", marginTop: "50px" }}
              >
                <div className="fa-flags">
                  <img
                    src={`/assets/language/${input.language_id}.png`}
                    alt=""
                  />
                  &nbsp;-&nbsp;{input.language_name}
                </div>

                <input
                  hidden
                  {...register(`descriptions[${index}].language_id`, {
                    required: `descriptions[${index}].language_id is required`,
                  })}
                  value={input.language_id}
                />

                <TextField
                  sx={{ mt: 1, minWidth: 3 / 4 }}
                  InputLabelProps={{ shrink: true }}
                  margin="normal"
                  required
                  fullWidth
                  id={"#name" + index.toString()}
                  type="text"
                  label="Name"
                  {...register(`descriptions[${index}].name`)}
                />

                <TextField
                  sx={{ mt: 1, minWidth: 3 / 4 }}
                  InputLabelProps={{ shrink: true }}
                  margin="normal"
                  fullWidth
                  multiline
                  rows={5}
                  id={"#description" + index.toString()}
                  type="text"
                  label="Description"
                  {...register(`descriptions[${index}].description`)}
                />
              </div>
            ))}
          </div>
        </Box>

        <p style={{ color: "red", textAlign: "center" }}>
          {errors?.descriptions?.toString()}
        </p>

        <Stack
          direction="row"
          spacing={2}
          sx={{
            mt: 2,
          }}
        >
          {/* <Button
              onClick={() => reset()}
              variant="outlined"
              startIcon={<DeleteIcon />}
              >
              Clear
              </Button> */}

          <Button
            size="large"
            sx={{ marginTop: "10px", marginBottom: "10px" }}
            href="/payment-methods"
          >
            Back
          </Button>
          <Button
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            size="large"
            endIcon={<SendIcon />}
            disabled={circularLoading}
            type="submit"
          >
            Send
            {circularLoading && (
              <CircularProgress
                size={24}
                sx={{
                  color: green[500],
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: "-12px",
                  marginLeft: "-12px",
                }}
              />
            )}
          </Button>
        </Stack>
      </Box>
    </Container>
  );
}
